/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getOnboardingSuggestedUsersSkeleton.defs.js'
export * as $defs from './getOnboardingSuggestedUsersSkeleton.defs.js'
